export const defaultComparator = (a, b) => a === b;